import styled from 'styled-components';

import ModalContent from './modal-content';

export const Content = styled(ModalContent)`
  flex-direction: column;
  position: absolute;
  top: 0;
  bottom: ${props => (props.disableFooter ? '0' : '81px')};
  height: auto;
  background: transparent;

  .modal-scroller {
    padding-top: 140px;

    ${Styles.desktop`
      padding-top: 170px;
    `}
  }

  .modal-inner {
    width: 100%;
    max-width: 100%;
  }
`;

export const HeroContainer = styled.div`
  display: flex;
  width: 100%;
  height: 140px;

  ${Styles.desktop`
    height: 170px;
  `}

  ${Styles.mobileFullscreen`
    height: calc(140px + env(safe-area-inset-top));
  `}
`;
